var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#229716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c7e12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdf32"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 4.57142857c-.84157676 0-1.52380953-.68223276-1.52380953-1.52380952s.68223277-1.52380953 1.52380953-1.52380953 1.52380952.68223277 1.52380952 1.52380953-.68223276 1.52380952-1.52380952 1.52380952zm0-1.52380952c.15863124 0-.12197825.80337999 0 .76190476.20158368-.06854279.76190476-1.01177857.76190476-1.14285714 0-.21039419-.34111638-.38095238-.76190476-.38095238s-.76190476.17055819-.76190476.38095238c0 .21039418.34111638.38095238.76190476.38095238z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.1904762 9.9047619-.538748.1577957.1577956-.53874808-.1577956-.53874803.538748.15779565.538748-.15779565-.1577956.53874803.1577956.53874808z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.1904762 2.66666667-.538748.15779564.1577956-.53874802-.1577956-.53874803.538748.15779564.538748-.15779564-.1577956.53874803.1577956.53874802z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.4761905 4.95238095-.5387481.15779564.1577957-.53874802-.1577957-.53874802.5387481.15779564.538748-.15779564-.1577956.53874802.1577956.53874802z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6666667 5.71428571-.5387481.15779565.1577957-.53874803-.1577957-.53874802.5387481.15779564.538748-.15779564-.1577957.53874802.1577957.53874803z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.3333333 6.66666667-.269374.07889782.0788978-.26937401-.0788978-.26937402.269374.07889783.2693741-.07889783-.0788979.26937402.0788979.26937401z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.18960952 4.22659829c-.32596137-.26098983-.73955771-.41707448-1.18960952-.41707448-1.05197095 0-1.9047619.85279096-1.9047619 1.9047619 0 1.05197095.85279095 1.90476191 1.9047619 1.90476191.45005181 0 .86364815-.15608465 1.18960952-.41707448-.17266933.06440745-.35956762.09961416-.55468891.09961416-.87664244 0-1.58730156-.71065912-1.58730156-1.58730159 0-.87664246.71065912-1.58730158 1.58730156-1.58730158.19512129 0 .38201958.03520671.55468891.09961416z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/CC.627959f7d8eabdbc7da4eb8068817434.svg";
export { ForwardRef as ReactComponent };